const SSO_ERROR_MESSAGES = {
  not_configured: 'Přihlášení přes Microsoft není nakonfigurováno. Použijte e-mail a heslo.',
  invalid_state: 'Přihlášení přes Microsoft selhalo (neplatný stav). Zkuste to znovu.',
  missing_code: 'Přihlášení přes Microsoft selhalo (chybí autorizační kód). Zkuste to znovu.',
  no_email: 'Microsoft účet neobsahuje e-mail. Kontaktujte podporu aplikace.',
  user_not_found:
    'Účet Microsoft není propojen s Compass. Přihlaste se e-mailem a heslem, nebo kontaktujte administrátora.',
  user_inactive: 'Uživatel není aktivní, nebylo možné Vás přihlásit.',
  employee_required:
    'Účet není propojen se zaměstnancem. Mobilní aplikace je dostupná jen pro zaměstnance.',
  oid_mismatch:
    'Tento Microsoft účet neodpovídá propojenému Compass uživateli. Kontaktujte administrátora.',
  tenant_mismatch: 'Microsoft účet nepatří do povolené organizace. Kontaktujte administrátora.',
  provider_error: 'Microsoft přihlášení bylo zrušeno nebo selhalo. Zkuste to znovu.',
  start_failed: 'Nepodařilo se zahájit přihlášení přes Microsoft. Zkuste to znovu později.',
  token_exchange_failed:
    'Nepodařilo se dokončit přihlášení přes Microsoft. Zkuste to znovu později.',
};

export const getMicrosoftSsoErrorMessage = (code) =>
  SSO_ERROR_MESSAGES[code] ||
  'Přihlášení přes Microsoft selhalo. Zkuste to znovu, nebo použijte e-mail a heslo.';
